<template>
  <vue-page-wrapper :title="htmlTitle" :bread-crumbs="breadCrumbItems">
    <stats-bar @filters="appliedFilters.dateFilter = $event"></stats-bar>
    <v-card>
      <vue-card-title
        :title="'Activity Logs'"
        :subtitle="'Here you can view overall activity logs'"
        :icon="$getIcon('mdiCommentAlertOutline')"
      >
        <template slot="actions">
          <top-contributors></top-contributors>
          <v-switch
            v-model="switch1"
            label="Remarks"
          ></v-switch>
          <v-btn icon @click="filter.show = !filter.show">
            <v-icon small v-text="$getIcon('mdiFilterVariant')"></v-icon>
          </v-btn>
        </template>
      </vue-card-title>
      <v-divider></v-divider>
      <v-slide-y-transition>
        <div v-show="filter.show">
          <v-row class="mx-3">
            <v-col cols="3" class="pt-4">
              <vue-auto-complete
                v-model="appliedFilters.users"
                endpoint="/api/v1/users/autocomplete/?cre_user=True"
                label="Users"
                clearable
                multiple
                :prepend-inner-icon="$getIcon('mdiAccount')"
                item-text="name"
                item-value="id"
              ></vue-auto-complete>
            </v-col>

            <v-col cols="3" class="pt-4">
              <vue-auto-complete
                v-model="appliedFilters.services"
                label="Service"
                :endpoint="
                  `/api/v1/crm/services/?organiation=${$store.state.shell.currentOrganizationId}`
                "
                multiple
                :prepend-inner-icon="$getIcon('mdiCart')"
                item-text="name"
                item-value="id"
                clearable
              ></vue-auto-complete>
            </v-col>

            <v-col cols="3" class="pa-0">
              <filter-generator
                v-model="appliedFilters"
                :align-center="false"
                :filters="filters"
              ></filter-generator>
            </v-col>

            <v-col cols="3">
              <v-autocomplete
                v-model="appliedFilters.stage"
                label="Stage"
                :items="stageList"
                :prepend-inner-icon="$getIcon('mdiCart')"
                item-text="name"
                item-value="id"
                cache-items
                clearable
                @focus="this.loadStage"
                @change="appliedFilters.stage = $event"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="mx-3">
            <v-col cols="3">
              <v-select
                v-model="appliedFilters.medium"
                label="Medium Type"
                :items="['Inbound', 'Outbound']"
                :prepend-inner-icon="$getIcon('mdiMagnify')"
              ></v-select>
            </v-col>
            <v-col cols="3">
              <vue-auto-complete
                v-model="appliedFilters.selectedClient"
                :endpoint="
                  `/api/v1/crm/clients/select/?organization__slug=${$store.state.shell.currentOrganizationId}`
                "
                :key="key"
                label="Search client"
                :prepend-inner-icon="$getIcon('mdiMagnify')"
                item-text="name"
                item-value="slug"
                clearable
                force-fetch
              >
              </vue-auto-complete>
            </v-col>
            <v-col cols="3">
              <v-select
                v-model="appliedFilters.priority"
                label="Priority"
                :items="[
                { text: 'All', value: 'All' },
                { text: 'Hot(-80%)', value: 'Critical' },
                { text: 'Warn(40%-80%)', value: 'Important' },
                { text: 'New/Lost(-20%)', value: 'Low' },
                { text: 'Oppt(20%-40%)', value: 'Normal' }
              ]"
                :prepend-inner-icon="$getIcon('mdiMagnify')"
              ></v-select>
            </v-col>
            <v-col cols="3">
              <vue-auto-complete
                v-model="appliedFilters.division"
                :endpoint="
                  `api/v1/crm/${$store.state.shell.currentOrganizationId}/divisions/?is_parent=True`
                "
                label="Department"
                :prepend-inner-icon="$getIcon('mdiMagnify')"
                item-text="name"
                item-value="slug"
                clearable
              >
              </vue-auto-complete>
            </v-col>
            <v-col v-if="appliedFilters.division" cols="3">
              <vue-auto-complete
                v-model="appliedFilters.sub_division"
                :endpoint="
                  `api/v1/crm/${$store.state.shell.currentOrganizationId}/divisions/?parent__slug=${appliedFilters.division}`
                "
                :key="subDivisionKey"
                label="Team"
                :prepend-inner-icon="$getIcon('mdiMagnify')"
                item-text="name"
                item-value="slug"
                clearable
              >
              </vue-auto-complete>
            </v-col>
          </v-row>
        </div>
      </v-slide-y-transition>
      <v-divider v-if="filter.show"></v-divider>
      <v-card-text class="pa-0">
        <v-data-table
          :headers="tableHeaders"
          :items="fetchedResults"
          :loading="loading"
          :sort-desc.sync="pagination.descending"
          :sort-by.sync="pagination.sortBy"
          :page.sync="pagination.page"
          :items-per-page.sync="pagination.rowsPerPage"
          :footer-props="footerProps"
          :server-items-length="pagination.totalItems"
          must-sort
          mobile-breakpoint="0"
          class="elevation-1"
        >
          <template v-slot:item="props">
            <tr>
              <td>
                <v-row align="center" no-gutters>
                  <v-avatar
                    @click="gotoClientDetail(props.item.client_slug)"
                    class="pointer"
                    tile
                    :size="35"
                  >
                    <v-img
                      :src="
                        $getProp(props.item, 'client_logo') ||
                          require(`@/static/images/info/user-default.png`)
                      "
                      alt="client avatar"
                    ></v-img>
                  </v-avatar>
                  <v-col class="text-left ml-2 font-weight-bold">
                    <div
                      @click="gotoClientDetail(props.item.client_slug)"
                      class="pointer"
                    >
                      {{ $getProp(props.item, "client_name") || "Fix null" }}
                    </div>
                  </v-col>
                </v-row>
              </td>
              <td>
                <div
                  v-if="
                    props.item.sub_stage_logs.length &&
                      props.item.sub_stage_logs[0].sales_achievements.length
                  "
                  class="font-weight-bold"
                >
                  {{
                    props.item.sub_stage_logs[0].sales_achievements &&
                      props.item.sub_stage_logs[0].sales_achievements[0].service
                        .name
                  }}
                </div>
                <div v-else>-</div>
                <div class="text--secondary">
                  {{ props.item.sub_stage_logs.length ? "Service" : "General" }}
                </div>
              </td>
              <td>
                <div>
                  {{ $dayjs(props.item.created_at).format("DD-MM-YYYY") }}
                </div>
                <div class="text--secondary">
                  {{ $dayjs(props.item.created_at).format("hh:mmA") }}
                </div>
              </td>
              <td class="text-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-hover>
                      <v-icon
                        v-if="
                          props.item.communicationlog &&
                            props.item.communicationlog.follow_up_datetime
                        "
                        v-on="on"
                        size="15"
                        v-text="$getIcon('mdiFlashRedEye')"
                        class="mr-1"
                        :color="
                          colorMapper[props.item.communicationlog.priority]
                        "
                      ></v-icon>
                      <v-icon
                        v-else
                        v-on="on"
                        size="20"
                        v-text="$getIcon('mdiFlash')"
                        class="mr-1"
                        :color="
                          colorMapper[props.item.communicationlog.priority]
                        "
                      ></v-icon>
                    </v-hover>
                    <v-row align="center" no-gutters>
                        <v-col class="text-center">
                          {{priorityChoices[props.item.communicationlog.priority]}}
                        </v-col>
                    </v-row>     
                  </template>
                  <span>
                    <div class="text-left">
                      <strong>Priority:</strong>
                      {{
                        (props.item.communicationlog &&
                          props.item.communicationlog.priority) ||
                          "None"
                      }}
                    </div>
                    <div
                      v-if="
                        props.item.communicationlog &&
                          props.item.communicationlog.follow_up_datetime
                      "
                    >
                      <strong>FollowUp:</strong>
                      {{
                        props.item.communicationlog &&
                        props.item.communicationlog.follow_up_datetime
                          ? $dayjs(
                              props.item.communicationlog.follow_up_datetime
                            ).format("DD-MM-YYYY")
                          : ""
                      }}
                      {{
                        props.item.communicationlog &&
                        props.item.communicationlog.follow_up_datetime
                          ? $dayjs(
                              props.item.communicationlog.follow_up_datetime
                            ).format("hh:mm A")
                          : ""
                      }}
                    </div>
                  </span>
                </v-tooltip>
              </td>
              <td>
                <v-row align="center" no-gutters>
                  <v-col class="text-left ml-2 font-weight-bold">
                    <div>
                      {{
                        $getProp(
                          props.item,
                          "communicationlog.contacted_with.name"
                        ) || "Fix null"
                      }}
                    </div>
                    <div class="caption grey--text">
                      {{
                        $getProp(
                          props.item,
                          "communicationlog.contacted_with.designation.name"
                        )
                      }}
                    </div>
                  </v-col>
                </v-row>
              </td>
              <td>
                <span
                  ><v-icon size="15" v-text="getTimeLineIcon(props.item)"></v-icon
                ></span>
                <span
                  ><v-icon
                    small
                    v-text="
                      getIconForLog(
                        $getProp(
                          props.item,
                          'communicationlog.medium_direction'
                        )
                      )
                    "
                  ></v-icon
                ></span>
                {{ props.item.communicationlog.medium_direction }}
              </td>
              <td align="center">
                <v-menu open-on-hover offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar class="mt-2 mb-1" v-bind="attrs" v-on="on" :size="20">
                      <v-img
                        :src="
                          $getProp(props.item, 'logged_by.picture') ||
                            require(`@/static/images/info/user-default.png`)
                        "
                        alt="CRE avatar"
                      ></v-img>
                    </v-avatar>
                      
                      <v-row align="center" no-gutters>
                        <v-col class="text-center">
                          <div>
                            {{ props.item.logged_by.full_name }}
                          </div>
                        </v-col>
                      </v-row>
                  </template>

                  <v-list>
                    <v-list-item>
                      <v-list-item-title>
                        <v-row align="center" no-gutters>
                          <v-avatar :size="35">
                            <v-img
                              :src="
                                $getProp(props.item, 'logged_by.picture') ||
                                  require(`@/static/images/info/user-default.png`)
                              "
                              alt="CRE avatar"
                            ></v-img>
                          </v-avatar>
                          <v-col
                            class="text-left ml-2 font-weight-bold caption"
                          >
                            <div>
                              {{
                                $getProp(props.item, "logged_by.full_name") ||
                                  "Fix null"
                              }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
              <td width="5%">
                {{
                  (props.item.sub_stage_logs.length &&
                    props.item.sub_stage_logs[0].sales_stage) ||
                    "-"
                }}
              </td>
              
              <td width="5%">
                <v-btn icon class="">
                  <v-icon
                    v-text="$getIcon('mdiEye')"
                    color="blue"
                    @click="(logInfoKey += 1), (logInfo = props.item)"
                  ></v-icon>
                </v-btn>
              </td>
              <td v-if="switch1">
                {{ props.item.communicationlog.remarks }}
              </td>
              
            </tr>
          </template>
          <template slot="no-data">
            <vue-data-table-no-data :loading="loading"></vue-data-table-no-data>
          </template>
        </v-data-table>
      </v-card-text>
      <log-detail
        :key="logInfoKey"
        v-if="logInfo"
        :logInfo.sync="logInfo"
      ></log-detail>
    </v-card>
  </vue-page-wrapper>
</template>
<script>
import DataTableMixin from "@/mixins/dataTableMixin";
import mediumIcons from "@/utils/mediumIcons.js";
import FilterGenerator from "@/components/common/layout_utils/FilterGenerator";
import cancelRequestMixin from "@/mixins/cancelRequestMixin";
import StatsBar from "@/components/crm/activity_logs/statsBar";
import TopContributors from "@/components/crm/activity_logs/topContributors";

export default {
  mixins: [DataTableMixin, cancelRequestMixin],
  mediumIcons,
  props: {
    clientSlug: {
      type: String,
      default: undefined
    }
  },
  components: {
    LogDetail: () => import("@/components/crm/client/components/LogDetail"),
    FilterGenerator,
    StatsBar,
    TopContributors
  },
  data() {
    return {
      subDivisionKey: 0,
      stageList: [],
      colorMapper: {
        Critical: "red",
        Important: "orange",
        Normal: "green",
        Low: "blue",
      },
      switch1: false,
      priorityChoices: {
        "Critical": "Hot(-80%)",
        "Important": "Warn(40%-80%)",
        "Normal": "Oppt(20%-40%)",
        "Low": "New/Lost(-20%)",
      },
      filters: [
        {
          component: "vue-date-picker",
          bind: "dateFilter",
          props: { label: "Select Date", default: "This Week" }
        }
      ],
      headers: [
        {
          text: "Client Name",
          align: "left",
          sortable: false,
          class: "grey lighten-4",
          width: "15%",
        },
        {
          text: "Product / Log Type",
          align: "left",
          sortable: false,
          class: "grey lighten-4",
        },
        {
          text: "Date/Time",
          align: "left",
          sortable: false,
          class: "grey lighten-4",
          width: "10%",
        },
        {
          text: "Priority",
          align: "left",
          sortable: false,
          class: "grey lighten-4"
        },
        {
          text: "Contact Person",
          align: "left",
          sortable: false,
          class: "grey lighten-4"
        },
        {
          text: "Medium",
          align: "center",
          sortable: false,
          class: "grey lighten-4"
        },
        {
          text: "User",
          align: "center",
          sortable: false,
          class: "grey lighten-4"
        },
        {
          text: "Stage",
          align: "left",
          sortable: false,
          class: "grey lighten-4"
        },
        
        {
          text: "Actions",
          align: "left",
          sortable: false,
          class: "grey lighten-4"
        },
        
      ],
      remarksHeader: 
        {
          text: "Remarks",
          align: "left",
          sortable: false,
          class: "grey lighten-4",
          width: "10%"
        },
      
      loading: false,
      appliedFilters: {},
      filter: {
        dateFilter: {},
        activeStatus: 0,
        show: false
      },
      status: "",
      logInfo: null,
      logInfoKey: 1,
      htmlTitle: "Activity Logs",
      breadCrumbItems: [{ text: "Activity Logs", disabled: true }],
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      urlParams: "",
      key: 0
    };
  },
  watch: {
    "appliedFilters.division": {
      handler(newVal) {
        if (newVal) {
          this.subDivisionKey += 1;
        }
      }
    }
  },
  mounted() {
    if (this.$route.query.client) {
      this.appliedFilters.selectedClient = this.$route.query.client || "";
      this.appliedFilters.priority = "All";
      this.key = 1;
    }
  },
  methods: {
    getJobPositions(value, isTruncated = false) {
      const jobPositionsArray = value?.data?.job_positions || ["N/A"];
      return isTruncated
        ? this.truncate(jobPositionsArray.join(", "), 15)
        : jobPositionsArray.join(", ");
    },
    truncate(text, length, suffix) {
      if (!text) return "";
      let truncatedText = "";
      suffix = suffix || "...";
      if (text.length > length) {
        truncatedText = text.substring(0, length) + suffix;
      } else {
        truncatedText = text.substring(0, length);
      }
      return truncatedText;
    },
    fetchDataTable() {
      this.loading = true;
      this.$axios
        .$get(this.fetchAPI, {
          params: this.fullParams
        })
        .then(response => {
          this.loadDataTable(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadStage() {
      const stageEndPoint = `/api/v1/crm/sales-stages/?fetch_all=true&organization__slug=${this.$store.state.shell.currentOrganizationId}`;
      this.$axios
        .$get(stageEndPoint)
        .then(response => {
          this.stageList = response;
        })
        .catch(error => this.formValidator.setError(error.response.data));
    },
    gotoClientDetail(clientSlug) {
      this.$router.push(`/clients/${clientSlug}`);
    },
    getIconForLog(direction) {
      if (direction === "Inbound") {
        return this.$getIcon("mdiArrowLeft");
      } else {
        return this.$getIcon("mdiArrowRight");
      }
    },
    setStatus(status) {
      this.selectedTab = status === "All" ? "" : status;
      this.pagination.page = 1;
    },
    getTimeLineIcon(log) {
      if (log.communicationlog) {
        return this.$options.mediumIcons[
          this.$getProp(log, "communicationlog.medium.icon")
        ];
      }
      return this.$getIcon("mdiClipboardText");
    }
  },
  computed: {
    tableHeaders (){
      if (this.switch1) {
        // If switch1 is true, append 'remarksHeader' to 'headers'
        return this.headers.concat(this.remarksHeader);
      } else {
        // If switch1 is false, use 'headers' as is
        return this.headers;
      }
    },

    fetchAPI() {
      
      let api = "";
      if (this.clientSlug) {
        api = `/api/v1/crm/logs/?organization=${this.$store.state.shell.currentOrganizationId}&client__slug=${this.clientSlug}`;
      } else {
        api = `/api/v1/crm/logs/?organization=${this.$store.state.shell.currentOrganizationId}`;
      }
      return `${api}${this.urlParams}`;
    },
    DataTableFilter() {
      return {
        start_at:
          (this.appliedFilters.dateFilter &&
            this.appliedFilters.dateFilter.start_date) ||
          "",
        end_at:
          (this.appliedFilters.dateFilter &&
            this.appliedFilters.dateFilter.end_date) ||
          "",
        users:
          (this.appliedFilters.users &&
            this.appliedFilters.users.length &&
            this.appliedFilters.users.toString()) ||
          "",
        services:
          (this.appliedFilters.services &&
            this.appliedFilters.services.length &&
            this.appliedFilters.services.toString()) ||
          "",
        stage: this.appliedFilters.stage || "",
        client_slug: this.appliedFilters.selectedClient || "",
        medium_direction: this.appliedFilters.medium || "",
        division: this.appliedFilters.division || "",
        sub_division: this.appliedFilters.sub_division || "",
        priority:
          this.appliedFilters.priority === "All"
            ? ""
            : this.appliedFilters.priority
            ? this.appliedFilters.priority
            : ""
      };
    }
  }
};
</script>
